export default "__VITE_ASSET__PUvY9V$I__"